export const base_profile = {
	id: "",
	name: "",
	email: "",
	phone: "",
	description: "",
};

export const customStyles = {
	control: (base, state) => ({
		...base,
		background: "#f3f3f3",
		border: "none",
		height: "1px",
		boxShadow: state.isFocused ? null : null,
	}),
};
